// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"53":"b22d889e","134":"db4cddb6","555":"055a114d"}[chunkId] + ".js";
};